<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="approvalTypes"
    item-value="id"
    item-text="name"
    clearable
    return-object
  >
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ApprovalTypeField",
  props: {
    value: Object,
    status: { type: String, required: false }
  },
  data: () => ({
    approvalTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    ApiService.post("/api/approvalTypes/search?size=100", { isEffective: this.status }).then(({ data }) => {
      this.approvalTypes = data.content;
    });
  }
};
</script>
